import { render, staticRenderFns } from "./MailForm.vue?vue&type=template&id=3ef98834"
import script from "./MailForm.vue?vue&type=script&lang=js"
export * from "./MailForm.vue?vue&type=script&lang=js"
import style0 from "./MailForm.vue?vue&type=style&index=0&id=3ef98834&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports